module.exports = __webpack_public_path__ + "img/ego_camel.0b17b2a5.svg";